import { GridController, gridTpl } from '../../../../../common/grid/grid.controller';
import * as Actions from '../adm-accounts-clients.actions'
import { IDS } from '../adm-accounts-clients-action-id.constants';

class AdmAccountsClientsGridController extends GridController {
    /* @ngInject */
    constructor($ngRedux, $state, NavigationService, $filter, $mdDialog) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
    }

    $onInit() {
        this.module = 'administration';
        this.identifier = IDS.admAccountsClients;
        this.statePath = IDS.admAccountsClientsGrid;
        this.filterTemplate = './adm-accounts-clients-grid-filter.html';
        this.filterOpen = true;
        this.filterExpandButtonVisible = false;
        this.exportComponent = false;
        this.confirmDialogOnRemove = true;

        // const translateType = (row) => {
        //   const key = `ADMINISTRATION.CLIENT_ACCOUNT_TYPES.${row.type_code.toUpperCase()}`;
        //   const translated = this.$filter('translate')(key);
        //   return translated !== key ? translated : row.type_name;
        // }

        this.columns = [
            {title: '#',                            mapper: null},
            {title: 'Account Name',                 mapper: 'name'},
            {title: 'Single Sign On',               mapper: 'sso_enabled'},
            {title: 'Two Factor Authentication',    mapper: 'two_factor_auth'},
            {title: 'Outsourced by',                mapper: 'outsourced_management_provider'},
        ];

        this.unsubscribe = this.$ngRedux.connect(
            this.mapState().bind(this), Actions)(this);

        this.dataAction = this.fetchClientAccounts;
        // this.exportService = this.fetchAccountsClients;
        this.filter.identifier = this.identifier;
        this.filter.statePath = this.statePath;

        this.init();
    }

    $onDestroy() {
        this.destroy();
    }
}

export const admAccountsClientsGrid = {
    bindings: {
        title: '@',
        onSelect: '&',
        onReport: '&',
        onRemove: '&',
        onReset: '&'
    },
    controller: AdmAccountsClientsGridController,
    ...gridTpl
};
